import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VTextField } from 'vuetify/lib';

Vue.use(Vuetify, { components: { VTextField } });

export default new Vuetify({
	icons: {
		iconfont: 'fa',
	},
});
